// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2SVMW","footer":"ModalFilter_footer__y4gSH"};